import { Component } from '@angular/core';

@Component({
    selector: 'victor-santacana',
    template: require('./victor-santacana.component.html'),
})

export class VictorSantacanaComponent {    

    constructor() {
    
    }
    
    navigateURL(url: string) {
        window.open(url, '_blank');
    }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/projects/victor_santacana/victor-santacana.component.ts
 **/